<template>
  <Fragment>
    <slot></slot>
  </Fragment>
</template>

<script>
import _ from 'lodash';
import { Fragment } from 'vue-fragment';

export default {
  props: {
    event: {
      type: String,
      required: true
    },
    target: [Object, String]
  },
  components: {
    Fragment
  },
  methods: {
    listener() {
      this.$wzBus.$emit('event', { event: this.event, target: this.target });
    }
  },
  mounted() {
    const el = _.get(this, '$slots.default[0].elm');

    if (!el) {
      return;
    }

    if (el.classList) {
      el.classList.add(JSON.stringify(this.target));
    }

    // attach event listener
    el.addEventListener(this.event, this.listener);
  },
  destroyed() {
    const el = _.get(this, '$slots.default[0].elm');
    if (!el) {
      return;
    }

    // remove event listener
    setTimeout(() => el.removeEventListener(this.event, this.listener), 100);
  }
};
</script>

<style></style>
